export const checkImageDimension = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function () {
      if (this.width === 450 && this.height === 450) {
        resolve(true);
      } else {
        resolve(false);
      }
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
};

export const hexToColorName = (hex) => {
  const colorMap = {
    "#000000": "Black",
    "#FFFFFF": "White",
    "#FF0000": "Red",
    "#00FF00": "Green",
    "#0000FF": "Blue",
    "#FFFF00": "Yellow",
    "#FF00FF": "Magenta",
    "#00FFFF": "Cyan",
    "#808080": "Gray",
    "#800000": "Maroon",
    "#008000": "Green",
    "#000080": "Navy",
    "#808000": "Olive",
    "#800080": "Purple",
    "#008080": "Teal",
    "#C0C0C0": "Silver",
    "#FFA500": "Orange",
    "#FFC0CB": "Pink",
    "#A52A2A": "Brown",
    "#FFD700": "Gold",
  };
  return colorMap[hex.toUpperCase()] || null;
};

export const colorNameToHex = (colorName) => {
  if (!colorName) return null;

  const nameMap = {
    black: "#000000",
    white: "#FFFFFF",
    red: "#FF0000",
    green: "#00FF00",
    blue: "#0000FF",
    yellow: "#FFFF00",
    magenta: "#FF00FF",
    cyan: "#00FFFF",
    gray: "#808080",
    grey: "#808080",
    maroon: "#800000",
    navy: "#000080",
    olive: "#808000",
    purple: "#800080",
    teal: "#008080",
    silver: "#C0C0C0",
    orange: "#FFA500",
    pink: "#FFC0CB",
    brown: "#A52A2A",
    gold: "#FFD700",
  };

  const normalizedName = colorName.trim().toLowerCase();

  if (normalizedName.match(/^#[0-9a-f]{6}$/i)) {
    return normalizedName.toUpperCase();
  }

  return nameMap[normalizedName] || null;
};
